import client from "./client"
import { Response } from "../Model"

interface TermsAndConditionData {
    content: string
    version: string
}
interface RenewalTermsAndConditionData {
    isEnable: boolean
    content: string
    version: string
}
interface TermsAndConditionAcceptResponse {
    membershipId: number
    agreed: boolean
    version: string
}

const getTermsAndConditions = (membershipId: number) => {
    return client.get<Response<TermsAndConditionData>>(
        `membership/terms-and-conditions`,
        {
            params: {
                membershipId: membershipId,
            },
        },
    )
}
const getTermsAndConditionsForRenewalPeriod = (renewalPeriodId: number) => {
    return client.get<Response<RenewalTermsAndConditionData>>(
        `membership/terms-and-conditions/${renewalPeriodId}`,
    )
}
const getAcceptPath = (membershipId: number): string => {
    return `membership/${membershipId}/terms-and-conditions/accept`
}
const acceptTermsAndCondition = (membershipId: number, versionValue: string) => {
    return client.put<Response<TermsAndConditionAcceptResponse>>(
        getAcceptPath(membershipId), {version: versionValue},
    )
}

export type { TermsAndConditionData }
export { getTermsAndConditions, acceptTermsAndCondition, getTermsAndConditionsForRenewalPeriod }
